import _t from 'i18n!nls/front-page';

export const getMostPopularCertsMetaData = () => ({
  sectionTitle: _t('Specializations and Professional Certificates'),
  title: _t('Most Popular Certificates'),
  subtitle: _t('Explore our most popular programs, get job-ready for an in-demand career.'),
  callToActionLink: `/professional-certificates`,
});
